:host {
  display: contents;
}

audio {
  display: none;
}